// Luxury home background with navy overlay for premium section treatment.
export const SectionBg = ({ img, strength = 0.9 }) => (
  <>
    <div
      aria-hidden="true"
      className="absolute inset-0 bg-cover bg-center"
      style={{ backgroundImage: `url(/assets/${img})` }}
    />
    <div
      aria-hidden="true"
      className="absolute inset-0"
      style={{
        background: `linear-gradient(180deg, rgba(0,0,99,${Math.min(0.98, strength + 0.05)}), rgba(0,0,99,${strength}), rgba(0,0,99,${Math.min(0.98, strength + 0.05)}))`,
      }}
    />
  </>
);
